import axios from 'axios';
import { AdresseIP } from './AdresseIp';

export class BatimentService {

     constructor(){
        this.adresse = new AdresseIP()
    }
    
    getAll() {
        
        return axios.get(this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/batiment')
                    .then(res => res.data);
    }
    create(newBatiment) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/batiment'
        return axios.post(url,newBatiment)
                    .then(res => res.data);
    }
    update(idBatiment ,newBatiment) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/batiment/'
        return axios.put(url+idBatiment, newBatiment)
                    .then(res => res.data);
    }
    delete(idBatiment) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/batiment/'
        return axios.patch(url+idBatiment)
                    .then(res => res.data)
    }
    get(idCite) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/batiment/?idCite='+idCite
        return axios.get(url)
                    .then(res => res.data)
    }

}